<div
	class="btn-bar feedback-item-toolbar visible-when-active pull-right"
	role="application"
>
	<!-- Emoji button -->
	<ngx-comment-reactions
		*ngIf="!feedbackItem.was_ai_generated"
		class="add-mode"
		[mode]="modes.ADD"
		[comment]="feedbackItem"
		(setSelectedComment)="setSelectedComment.emit(feedbackItem)"
	>
	</ngx-comment-reactions>

	<!-- AI Feedback button -->
	<ngx-comment-reactions
		*ngIf="feedbackItem.was_ai_generated && !isSelfDemo"
		class="feedback-mode"
		[mode]="modes.FEEDBACK"
		[comment]="feedbackItem"
		(setSelectedComment)="setSelectedComment.emit(feedbackItem)"
	>
	</ngx-comment-reactions>

	<span
		*ngIf="feedbackItem.was_ai_generated && !isSelfDemo"
		class="divider"
	></span>

	<!-- Reply button -->
	<button
		*ngIf="showReplyButton()"
		class="btn btn-xs reply-btn"
		[matTooltip]="
			'feedback-session-feedback-tree-comment_reply-comment' | translate
		"
		(click)="reply()"
	>
		<i class="ficon-reply"></i>
	</button>

	<!-- Read Receipt button -->
	<button
		*ngIf="feedbackItem.viewed_by_others"
		class="btn btn-xs viewer-btn"
		[matTooltip]="
			'feedback-session-feedback-tree-comment_read-receipts' | translate
		"
		(click)="getCommentViewers($event, feedbackItem)"
		#overlayOrigin
	>
		<i class="ficon-app-preview"></i>
	</button>

	<button
		type="button"
		*ngIf="mayEdit()"
		(click)="setSelectedComment.emit(feedbackItem)"
		[matMenuTriggerFor]="commentMenu"
		class="btn btn-xs menu-btn"
		[attr.aria-label]="'session-list-item_view-options' | translate"
	>
		<i class="ficon-app-dots-vertical"></i>
	</button>

	<mat-menu #commentMenu="matMenu" class="action-menu">
		<button
			mat-menu-item
			class="edit-btn"
			*ngIf="mayEdit()"
			(click)="edit.emit(feedbackItem)"
		>
			{{ "common_edit" | translate }}
		</button>
		<button
			mat-menu-item
			class="remove-btn"
			*ngIf="mayEdit()"
			(click)="confirmRemove()"
		>
			{{ "common_delete" | translate }}
		</button>
		<button
			mat-menu-item
			class="manage-ai-markers-btn"
			*ngIf="shouldShowManageAiMarkersButton()"
			(click)="openAiMarkers($event)"
		>
			{{
				"feedback-session-feedback-display_manage-ai-markers-tour_link"
					| translate
			}}
		</button>
	</mat-menu>
</div>
